import React from "react"
import { Card } from "@mui/material"
import MDTypography from "components/MDTypography"
import MDButton from "components/MDButton"

interface ConfirmPopupProps {
  isOpen: boolean
  message: string
  buttonName: string
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmPopup: React.FC<ConfirmPopupProps> = ({ isOpen, message, buttonName, onConfirm, onCancel }) => {
  return isOpen ? (
    <div className="modal-bg-cover">
      <Card
        sx={{
          width: "90%",
          maxWidth: "500px",
          padding: "20px",
          textAlign: "center",
          position: "relative"
        }}
      >
        {/* 閉じるボタン（右上に配置） */}
        <button
          className="close-button"
          onClick={onCancel}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            border: "none",
            background: "none",
            fontSize: "1.5rem",
            cursor: "pointer"
          }}
        >
          ×
        </button>

        <MDTypography variant="h5" fontWeight="medium">
          確認
        </MDTypography>

        <div style={{ marginTop: "20px", fontSize: "0.9em", whiteSpace: "pre-line" }}>{message}</div>

        {/* OKボタン */}
        <div style={{ marginTop: "20px" }}>
          <MDButton
            variant="contained"
            color="info"
            fullWidth
            sx={{
              borderRadius: "4px",
              textTransform: "none",
              fontSize: "1rem",
              padding: "0.75rem 0",
              backgroundColor: "#1976d2",
              "&:hover": {
                backgroundColor: "#1565c0"
              }
            }}
            onClick={onConfirm}
          >
            {buttonName}
          </MDButton>
        </div>
      </Card>
    </div>
  ) : null
}

export default ConfirmPopup
